import { isMobileAny } from '../../utils/device';
import { getAppElement } from '../app/utils';
import { NavigationPageAccesses } from '../toolNavigationBuilder/types';


export const urlToTestId = (url: string) => {
	if (!url || !url.trim()) return '';

	let normalized = url.charAt(0) === '/' ? url.slice(1) : url;
	normalized = normalized.split('/').join('-');

	return `toolNavigationLink_${normalized}`;
};
export const getPageAccessData = () => {
	const app = getAppElement();

	return JSON.parse(app.dataset.toolNavJson) as NavigationPageAccesses;
};

export const getNavItemDataTestId = (pageTypeId: number) => `toolNavigationItem_${pageTypeId}`;
export const getPrimaryLinkDataTestId = (pageTypeId: number) => `toolNavigationLinkPrimary_${pageTypeId}`;
export const getCollapseButtonDataTestId = (pageTypeId: number) => `toolNavigationCollapseButton_${pageTypeId}`;
export const getSupportNavItemDataTestId = (pageTypeId: number) => `toolNavigationSupportItem_${pageTypeId}`;

export function isExpandedInitially() {
	if (isMobileAny) {
		return false;
	}

	return getAppElement().classList.contains('app--tool-navigation-expanded');
}
